import React from 'react';
import NotificationItem2 from './NotificationItem2';
import { useFetchUserData } from '../hooks/user/useFetchUserData';
import { UserAuth } from '../Context';
import UserFollowedMe from './UserFollowedMe';
import NewFriendRequest from './NewFriendRequest';



function Notification({ notification,firstUserData,message,route }) {
  const { user } = UserAuth();
  return (
    <NotificationItem2  
      notification={notification} 
      message={message} 
      route={route}
      firstUserData={firstUserData}
      user={user}
      group={false}
    />
  )
}




export function FollowedMe({ notification}) {
  const message = ` started following you.`;
  const route = `/userProfile/${notification?.id[0]}`
  const userIds = notification?.id || [];
  const firstUserId = userIds[0];
  const { userData } = useFetchUserData(firstUserId);
  return <Notification notification={notification} message={message}  firstUserData={userData} route={route} />;
}

export function PostLike({ notification }) {
  const message = ` Liked your post.`
  const route = `/post/${notification.postId}`;
  const userIds = notification?.id || [];
  const firstUserId = userIds[0];
  const { userData } = useFetchUserData(firstUserId);
  return <Notification notification={notification} message={message} firstUserData={userData} route={route} />;
}

export function PostComment({ notification }) {
  const message = ` Commented on your post.`
  const route = `/post/${notification.postId}`;
  const userIds = notification?.id || [];
  const firstUserId = userIds[0];
  const { userData } = useFetchUserData(firstUserId);
  return <Notification notification={notification} message={message} firstUserData={userData} route={route}/>;
}

export function JoinedUser({ notification }) {
  const message = ` is now on lookflock.`
  const route = `/userProfile/${notification.id}`;
  const userId = notification?.id || [];
  const { userData } = useFetchUserData(userId);
  return <Notification notification={notification}  message={message} firstUserData={userData} route={route}/>;
}

export function InviteAccepted({ notification }) {
  const message =  ` accepted your invitation to join lookflock.`
  const route = `/userProfile/${notification.id}`;
  const userId = notification?.id || [];
  const { userData } = useFetchUserData(userId);
  return <Notification notification={notification}  message={message}  firstUserData={userData} route={route}/>;
}

export function ShoppingListChatMessage({ notification,user }) {
  const message = ` sent a message in your ${notification.shopList} shopping list chat.` 
  const route = `/shoppingList/${notification.listId}/${user.uid}`;
  const userIds = notification?.id || [];
  const firstUserId = userIds[0];
  
  const { userData } = useFetchUserData(firstUserId);
  return <Notification notification={notification} message={message}  firstUserData={userData} route={route}/>;
}
export function ShoppingListInvite({ notification,user }) {
  const message =  <>Invited you to <span style={{ fontFamily: 'Inter', color: "#000000", fontWeight: 500}}>{notification.shopList}</span> shopping list.</>
  const route = `/userProfile/${user?.uid}/shoppinglist/?listId=${notification?.listId}`;
  const userIds = notification?.id || [];
  const firstUserId = userIds[0];
  
  const { userData } = useFetchUserData(firstUserId);
  return <Notification notification={notification} message={message}  firstUserData={userData} route={route}/>;
}

export function FirstTimeListView({ notification,user }) {
  const message = ` Viewed your ${notification.shopList} shopping list for the first time.`
  const route = `/shoppingLists?name=${encodeURIComponent(notification.shopList)}&id=${notification.listId}`;
  const userIds = notification?.id || []; 
  const firstUserId = userIds[0];
  const { userData } = useFetchUserData(firstUserId);
  return <Notification notification={notification} message={message}  firstUserData={userData} route={route}/>;
}

export function ListProductLike({ notification,user }) {
  const message = ` Liked your product in ${notification.shopList} shopping list.`
  const route = `/shoppingList/${notification.listId}/${user.uid}`;
  const userIds = notification?.id || [];
  const firstUserId = userIds[0];
  const { userData } = useFetchUserData(firstUserId);
  return <Notification notification={notification}  message={message}  firstUserData={userData} route={route}/>;
}

export function FriendRequest({ notification,user }) {
  const message = ` Sent you a friend request.`
  const route = `/userProfile/${notification.id}`;
  const userIds = notification?.id || [];
  const firstUserId = userIds[0];
  const { userData } = useFetchUserData(firstUserId);
  return <NewFriendRequest notification={notification}  message={message}  firstUserData={userData} route={route} user={user}/>;
}

export function AcceptFriendRequest({ notification }) {
  const message = ` Accepted your friend request.`
  const route = `/userProfile/${notification.id}`;
  const userIds = notification?.id || [];
  const firstUserId = userIds[0];
  const { userData } = useFetchUserData(firstUserId);
  return <Notification notification={notification}  message={message}  firstUserData={userData} route={route}/>;
}


